import { render, staticRenderFns } from "./ot-due-date-label.vue?vue&type=template&id=f925c8dc&scoped=true&"
import script from "./ot-due-date-label.vue?vue&type=script&lang=ts&"
export * from "./ot-due-date-label.vue?vue&type=script&lang=ts&"
import style0 from "./ot-due-date-label.vue?vue&type=style&index=0&id=f925c8dc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f925c8dc",
  null
  
)

export default component.exports